/**
 @author xiaoye
 @date 2020/5/19 4:08 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
let share = config.baseUrl.pro

//获取数据库表的字段类型
let token01 = null;
export const SaveScreenPage = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/SaveScreenPage",
        method: "post",
        data: data,
        token: token01.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


let token02 = null;
export const GetScreenPageNameVerify = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenPageNameVerify?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

//获取数据库表的字段类型
// let token03 = null;
// export const GetScreenPageIndexByID = async (data) => {
//     if (token03) {
//         token03.cancel({status: 'cancel'});
//     }
//     token03 = axios.token();
//     return axios.ajax({
//         url: baseUrl.xy[6] + "/GetScreenPageIndexByID?" + qs.stringify(data),
//         method: "get",
//         token: token03.token,
//     })
// };

let token03 = null;
export const GetScreenPageIndexByID = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenPageIndexByID",
        method: "post",
        data: data,
        token: token03.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// 获取大屏下所有缩略图
let token04 = null;
export const GetScreenByGroupID = async (data) => {
    if (token04) {
        token04.cancel({status: 'cancel'});
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenByGroupID?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};

//大屏获取多维分析数据
let token05 = null;
export const GetScreenDataViews = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenDataViews?" + qs.stringify(data),
        method: "get",
        token: token05.token,
    })
};

//上传预览图
let token06 = null;
export const UploadPreviewPictureAsync = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/UploadPreviewPictureAsync",
        method: "post",
        data: data,
        token: token06.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//保存图表联动
let token07 = null;
export const CreateLinkAge = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/CreateLinkAge",
        method: "post",
        data: data,
        token: token07.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//根据验证码和分享的链接查看当前大屏数据
let token08 = null;
export const GetScreenLinkSharing = async (data) => {
    if (token08) {
        token08.cancel({
            status: 'cancel'
        });
    }
    token08 = axios.token();
    return axios.ajax({
        url: share.wb[0] + "/GetScreenLinkSharing",
        method: "post",
        token: token08.token,
        data: data,
        isNoQS: true,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
};